var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7354 0.104354C16.9441 0.256139 17.0295 0.45852 16.9916 0.711496L14.563 15.2829C14.5314 15.4663 14.4302 15.6086 14.2594 15.7098C14.1709 15.7604 14.0729 15.7857 13.9653 15.7857C13.8958 15.7857 13.8199 15.7699 13.7377 15.7383L9.44023 13.9833L7.14447 16.7818C7.03063 16.9273 6.87568 17 6.67963 17C6.59741 17 6.52784 16.9874 6.47092 16.9621C6.35076 16.9178 6.25273 16.8419 6.17684 16.7344C6.10727 16.6332 6.07248 16.5193 6.07248 16.3929V13.082L14.2689 3.03571L4.12773 11.8108L0.380518 10.274C0.146515 10.1855 0.0200273 10.0115 0.00105407 9.75223C-0.0115947 9.49926 0.0895957 9.31269 0.304626 9.19252L16.0903 0.0853799C16.1852 0.02846 16.2864 0 16.3939 0C16.5204 0 16.6342 0.0347845 16.7354 0.104354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.01cbba597c522ecc957eea2844e90bbd.svg";
export { ForwardRef as ReactComponent };